import React, { useState, useEffect } from 'react';
import {
  faPeopleArrows,
  faLayerGroup,
  faHousePersonLeave,
  faPersonWalkingArrowLoopLeft,
} from '@fortawesome/pro-solid-svg-icons';
import NavBarHome from '../Layouts/NavBarHome';
import FooterHome from '../Layouts/FooterHome';
import PageHeader from '../pagecomponents/PageHeader';
import profilingScreenshot from '../pagecomponents/screenshots/manager/6. Evaluation.png';
import placeholderComponent from '../pagecomponents/screenshots/placeholdercomponent.png';

// Nuevas imágenes para las secciones
import evaluationAndQuestions from '../pagecomponents/screenshots/evaluation/evaluationandquestions.png';
import TAPlevel from '../pagecomponents/screenshots/evaluation/TAPlevel.png';
import risklevel from '../pagecomponents/screenshots/evaluation/risklevel.png';
import sucession from '../pagecomponents/screenshots/evaluation/sucession.png';

import SectionBodyLeft from '../pagecomponents/SectionBodyLeft';
import SectionBodyRight from '../pagecomponents/SectionBodyRight';
import EconomicImpactStats from '../pagecomponents/EconomicImpactStats';
import FAQ from '../pagecomponents/FAQ';

const styles = {
  container: {
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
    fontWeight: '400',
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  main: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  sectionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '20px',
    padding: '40px 20px',
    backgroundColor: '#fff',
  },
};

export default function AnalysePage() {
  const [language, setLanguage] = useState(
    () => localStorage.getItem('language') || 'es'
  );

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const content = {
    es: {
      hero: {
        title: 'Evalúa el Talento con objetividad. Actúa con precisión.',
        intro:
          'Convierte la evaluación de personas en un proceso ágil, cuantificable y coherente. Adiós a los métodos desiguales entre managers. Bienvenido al análisis profesional de talento.',
        cta: 'Reservar Demo',
      },
      sections: [
        {
          title: 'Evaluación de Habilidades con Feedback de Compañeros',
          texts: [
            'Recopila valoraciones anónimas y estructuradas entre colegas para medir habilidades clave.',
            'Define niveles de dominio e identifica fortalezas.',
            'Detecta gaps de conocimiento y genera informes visuales para orientar el desarrollo.',
          ],
        },
        {
          title: 'Talent Assessment Process (TAP®)',
          texts: [
            'Clasifica a cada miembro según desempeño actual.',
            'Evalúa el potencial futuro.',
            'Identifica quienes necesitan acompañamiento y quienes están listos para más retos.',
          ],
        },
        {
          title: 'Evaluación de Riesgos de Rotación',
          texts: [
            'Calcula la probabilidad de rotación en los próximos meses.',
            'Mide el impacto en roles clave.',
            'Recibe alertas para tomar acción preventiva.',
          ],
        },
        {
          title: 'Evaluación de Sucesión',
          texts: [
            'Compara perfiles internos con requisitos de puesto.',
            'Diseña planes de crecimiento adaptados.',
            'Crea programas de mentoring alineados con las necesidades de negocio.',
          ],
        },
      ],
    },
    en: {
      hero: {
        title: 'Evaluate talent with objectivity. Act with precision.',
        intro:
          'Our platform transforms people assessment into an agile, measurable, and consistent process. Say goodbye to manager-by-manager differences. Welcome to professional talent analysis.',
        cta: 'Book a Demo',
      },
      sections: [
        {
          title: 'Skill Evaluation with Peer Feedback',
          texts: [
            'Collect structured, anonymous feedback from peers to assess key skills.',
            'Define mastery levels and identify strengths.',
            'Uncover knowledge gaps and generate visual reports to guide development.',
          ],
        },
        {
          title: 'Talent Assessment Process (TAP®)',
          texts: [
            'Classify each team member based on current performance.',
            'Evaluate future potential.',
            'Identify who needs support and who is ready for more challenges.',
          ],
        },
        {
          title: 'Turnover Risk Assessment',
          texts: [
            'Automatically calculate the probability of turnover in the coming months.',
            'Assess the impact on critical roles.',
            'Receive alerts to take preventive action.',
          ],
        },
        {
          title: 'Succession Planning',
          texts: [
            'Compare internal profiles with role requirements.',
            'Design tailored growth plans.',
            'Develop mentoring programs aligned with business needs.',
          ],
        },
      ],
    },
  };

  const lang = content[language] || content['es'];

  const handleDemoClick = () => {
    console.log('Reservar Demo clicked');
  };

  const icons = [
    faPeopleArrows,
    faLayerGroup,
    faHousePersonLeave,
    faPersonWalkingArrowLoopLeft,
  ];

  // Array de imágenes por sección
  const sectionImages = [
    evaluationAndQuestions,
    TAPlevel,
    risklevel,
    sucession,
  ];

  // Construcción de las secciones con sus imágenes
  const sections = lang.sections.map((item, idx) => ({
    icon: icons[idx],
    title: item.title,
    imageSrc: sectionImages[idx] || placeholderComponent,
    texts: item.texts,
  }));

  const impactStats = [
    {
      number: '17%',
      desc:
        language === 'es'
          ? 'Rotación media de empleados'
          : 'Average employee turnover',
    },
    {
      number: '80%',
      desc:
        language === 'es'
          ? 'Posiciones no cubiertas por planes de sucesión'
          : 'Bench not covered by current employees',
    },
    {
      number: '+12K€',
      desc:
        language === 'es'
          ? 'Coste medio por contratación (Directo + Indirecto)'
          : 'Average cost per hiring (Direct + Indirect)',
    },
  ];

  const faqs = {
    es: [
      {
        question:
          '¿Cómo garantiza la plataforma la objetividad en las evaluaciones de talento?',
        answer:
          'Nuestro sistema estandariza los procesos de análisis, utilizando preguntas muy concretas sobre acciones visibles y métricas cuantificables para minimizar los sesgos entre managers.',
      },
      {
        question:
          '¿Cuáles son los pasos del Talent Assessment Process (TAP®)?',
        answer:
          'Con base en las evaluaciones de desempeño y potencial, el sistema organiza a los empleados en una matriz de dos ejes y nueve valores, sin que tú tengas que hacer nada más.',
      },
      {
        question:
          '¿Cómo funciona la evaluación de habilidades con feedback de pares?',
        answer:
          'Se recopilan opiniones de colegas mediante un formulario estructurado; la información de sus respuestas se añadirá automáticamente y de forma ponderada a la evaluación de tu empleado.',
      },
      {
        question: '¿Cómo calcula el sistema el riesgo de rotación de personal?',
        answer:
          'Usamos algoritmos predictivos basados en el histórico de datos del empleado, encuestas de compromiso y factores clave para estimar la probabilidad de baja en los próximos meses.',
      },
      {
        question:
          '¿Puedo diseñar planes de sucesión adaptados a roles específicos?',
        answer:
          'Sí. Comparas perfiles internos con los requisitos del puesto, defines brechas y creas rutas de formación y mentoring alineadas con tus objetivos.',
      },
    ],
    en: [
      {
        question:
          'How does the platform guarantee objectivity in talent evaluations?',
        answer:
          'Our system standardizes the analysis processes by using highly specific questions about observable actions and quantifiable metrics to minimize manager-to-manager bias.',
      },
      {
        question:
          'What are the steps of the Talent Assessment Process (TAP®)?',
        answer:
          'Based on performance and potential assessments, the system places employees in a two-axis, nine-box matrix—without you having to do a thing.',
      },
      {
        question: 'How does the peer-feedback skills assessment work?',
        answer:
          'It gathers colleagues’ opinions through a structured form; their responses are automatically and proportionally incorporated into your employee’s evaluation.',
      },
      {
        question: 'How does the system calculate turnover risk?',
        answer:
          'We use predictive algorithms based on the employee’s historical data, engagement surveys, and key factors to estimate the likelihood of resignation in the coming months.',
      },
      {
        question: 'Can I design succession plans tailored to specific roles?',
        answer:
          'Yes. You can compare internal profiles with role requirements, identify skill gaps, and create training and mentoring paths aligned with your objectives.',
      },
    ],
  };

  return (
    <div style={styles.container}>
      <NavBarHome language={language} />

      <main style={styles.main}>
        <PageHeader
          title={lang.hero.title}
          subtitle={lang.hero.intro}
          ctaText={lang.hero.cta}
          onCtaClick={handleDemoClick}
          imageSrc={profilingScreenshot}
        />

        <div style={styles.sectionsContainer}>
          {sections.map((sec, i) => {
            // 1ª y 3ª sección: izquierda; 2ª y 4ª: derecha
            const Component = [
              SectionBodyLeft,
              SectionBodyRight,
              SectionBodyLeft,
              SectionBodyRight,
            ][i];
            return (
              <Component
                key={i}
                icon={sec.icon}
                title={sec.title}
                imageSrc={sec.imageSrc}
                texts={sec.texts}
              />
            );
          })}
        </div>

        {/* Economic Impact Stats Section */}
        <EconomicImpactStats stats={impactStats} language={language} />

        {/* FAQs Section */}
        <FAQ items={faqs[language]} language={language} />
      </main>

      <FooterHome language={language} setLanguage={setLanguage} />
    </div>
  );
}
